<template>
  <el-container class="myContainer">
    <el-main class="myContainer">
      <div style="height: 100%;width: 100%;display: flex;flex-direction: row">
        <PdfView :url="currentUrl" style="width:100%;height: 100%"></PdfView>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import {Refresh} from '@element-plus/icons-vue'
import PdfView from "@/views/applications/help/PdfView.vue";
export default {
  name: "HelpPdf",
  components: {PdfView, Refresh},
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      helpCatalogData: [],
      currentHelpCatalogData: {},
      currentFile: {},
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      currentUrl:''
    }
  },
  provide() {
    return {
      $fn: {
      }
    }
  },
  methods: {
    //获取文件目录
    async loadHelpCatalogFile(fileId) {
      if(fileId ===undefined){
        this.currentUrl = '';
        return;
      }
      let params = {fileId:fileId};
      this.currentUrl = await this.$http('helpService.getHelpFileUrl',params);
      console.log(this.currentUrl);
      let baseUrl = window.location.protocol +'//'+ window.location.host + '/'
      const index = this.currentUrl.indexOf('fileServer');
      let newUrl = '';
      if (index !== -1) {
        newUrl = this.currentUrl.substring(0,index) ;
      }
      if (baseUrl !== newUrl){
        this.currentUrl = baseUrl + this.currentUrl.substring(index);
      }
    }
  },
  created() {
    this.loadHelpCatalogFile(this.parentData.file_id);
  }
}
</script>

<style lang="less" scoped>
@import 'src/global';

.myContainer {
  padding: 5px;
}

.myTree {
  margin-left: -20px;

  :deep(.el-tree-node__content) {
    padding: 0 !important;
  }

  :deep(.el-tree-node) {
    position: relative;
    padding-left: 16px;
  }

  :deep(.el-tree-node__children) {
    padding-left: 16px;
  }

  // 竖线
  :deep(.el-tree-node::before) {
    content: "";
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #b8b9bb;
  }

  :deep(.el-tree-node:last-child::before) {
    height: 38px;
  }

  // 横线
  :deep(.el-tree-node::after) {
    content: "";
    width: 24px;
    height: 20px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #b8b9bb;
  }

  :deep(& > .el-tree-node::after) {
    border-top: none;
  }

  :deep(& > .el-tree-node::before) {
    border-left: none;
  }

  :deep(.el-tree-node__expand-icon) {
    font-size: 16px;
  }

  :deep(.is-leaf) {
    display: none; // 也可以去掉
  }
}
</style>